<template>
  <svg
    class="operation-icon-svg"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g v-if="name === 'charging'">
      <rect x="9" y="6" width="20" height="35" rx="3" />
      <path d="M15 13h8M18 19l-3 6h5l-2 7 7-9h-5l3-4" />
      <path d="M29 15h4a4 4 0 014 4v12a4 4 0 004 4" />
      <circle cx="41" cy="36" r="2" />
    </g>
    <g v-else-if="name === 'aggregate'">
      <circle cx="24" cy="10" r="5" />
      <circle cx="10" cy="35" r="5" />
      <circle cx="38" cy="35" r="5" />
      <path d="M20.5 14L13 30M27.5 14L35 30M15 35h18" />
      <circle cx="24" cy="26" r="4" />
    </g>
    <g v-else-if="name === 'data'">
      <rect x="5" y="8" width="38" height="27" rx="3" />
      <path d="M15 42h18M24 35v7M12 28l7-8 6 5 10-11" />
      <circle cx="12" cy="28" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="19" cy="20" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="25" cy="25" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="35" cy="14" r="1.5" fill="currentColor" stroke="none" />
    </g>
    <g v-else-if="name === 'community'">
      <path d="M7 41V18l13-6v29M20 41V7l20 8v26M4 41h40" />
      <path d="M12 23h3M12 29h3M12 35h3M26 19h4M34 19h3M26 26h4M34 26h3M26 33h4M34 33h3" />
    </g>
    <g v-else-if="name === 'public'">
      <circle cx="24" cy="24" r="18" />
      <path d="M6 24h36M24 6c6 5 9 11 9 18s-3 13-9 18c-6-5-9-11-9-18s3-13 9-18z" />
      <path d="M25 13l-5 9h6l-3 12 9-15h-6l3-6" />
    </g>
    <g v-else-if="name === 'highway'">
      <path d="M16 5L6 43M32 5l10 38M24 7v8M24 21v8M24 35v8" />
      <path d="M11 32h26M14 20h20" />
    </g>
    <g v-else-if="name === 'truck-swap'">
      <path d="M5 15h23v20H5zM28 23h8l7 7v5H28" />
      <circle cx="13" cy="38" r="4" />
      <circle cx="35" cy="38" r="4" />
      <path d="M11 10h18M11 10l4-4M11 10l4 4M37 17H19M37 17l-4-4M37 17l-4 4" />
    </g>
    <g v-else-if="name === 'solar-carport'">
      <path d="M5 20l7-10h27l5 10H5zM9 20h30M13 20v22M35 20v22" />
      <path d="M12 10l4 10M20 10l2 10M28 10l-2 10M36 10l-4 10" />
      <path d="M16 34l3-7h10l3 7v5H16z" />
      <circle cx="20" cy="39" r="2.5" />
      <circle cx="28" cy="39" r="2.5" />
    </g>
    <g v-else-if="name === 'green'">
      <path d="M24 43V23M24 31c-8 0-14-5-15-14 9 0 15 5 15 14zM24 24c8 0 14-5 15-14-9 0-15 5-15 14z" />
      <path d="M18 43h12M20 15l-4 6M28 14l4 5" />
    </g>
    <g v-else-if="name === 'space'">
      <circle cx="24" cy="24" r="17" />
      <circle cx="24" cy="24" r="7" />
      <path d="M24 7v10M24 31v10M7 24h10M31 24h10M12 12l7 7M29 29l7 7" />
    </g>
    <g v-else-if="name === 'comfort'">
      <path d="M7 29h34M12 29v10M36 29v10M10 22c5-7 23-7 28 0" />
      <path d="M17 13c1-5 6-8 11-6 4 1 7 5 7 9M30 6l2-4M38 11l4-2" />
    </g>
    <g v-else-if="name === 'shield'">
      <path d="M24 5l15 6v11c0 10-6 17-15 21-9-4-15-11-15-21V11l15-6z" />
      <path d="M18 24l4 4 9-10" />
    </g>
    <g v-else-if="name === 'multi-grid'">
      <circle cx="10" cy="12" r="4" />
      <path d="M10 3v3M10 18v3M1 12h3M16 12h3M4 6l2 2M14 16l2 2M4 18l2-2M14 8l2-2" />
      <path d="M28 7v34M28 14l-8 5M28 14l8 5M28 14v-7" />
      <rect x="36" y="27" width="9" height="14" rx="1" />
      <path d="M38 31h5M38 35h5M6 41h39M14 33h10" />
    </g>
    <g v-else-if="name === 'demand'">
      <path d="M5 27h7l4-10 7 19 6-14 5 5h9" />
      <path d="M10 10a18 18 0 0128 5M38 15v-7M38 15h-7M38 38a18 18 0 01-28-5M10 33v7M10 33h7" />
    </g>
    <g v-else-if="name === 'microgrid'">
      <circle cx="24" cy="8" r="4" />
      <circle cx="9" cy="36" r="4" />
      <circle cx="39" cy="36" r="4" />
      <rect x="19" y="20" width="10" height="10" rx="2" />
      <path d="M22 12l-9 20M26 12l9 20M13 36h22M24 16v4M24 30v6" />
    </g>
    <g v-else-if="name === 'virtual-plant'">
      <path d="M6 42h36M10 42V23l9-5v24M19 42V12l10 5v25M29 42V26l9-4v20" />
      <path d="M14 28h2M14 34h2M23 22h2M23 29h2M23 36h2M33 30h2M33 36h2" />
      <circle cx="36" cy="10" r="5" />
      <path d="M36 5V2M36 18v-3M28 10h3M41 10h3M31 5l2 2M39 13l2 2" />
    </g>
    <g v-else-if="name === 'power-trade'">
      <circle cx="24" cy="24" r="18" />
      <path d="M12 31l7-8 6 5 10-13M29 15h6v6" />
      <path d="M15 37h18M16 11h16" />
    </g>
    <g v-else-if="name === 'vehicle-grid'">
      <path d="M8 28l4-11h24l4 11v9H8zM12 17l4-7h16l4 7" />
      <circle cx="15" cy="37" r="3" />
      <circle cx="33" cy="37" r="3" />
      <path d="M15 24h18M7 8h13M7 8l4-4M7 8l4 4M41 14H28M41 14l-4-4M41 14l-4 4" />
    </g>
    <g v-else-if="name === 'transport-energy'">
      <path d="M7 35l7-17h20l7 17v6H7zM14 18l4-7h12l4 7" />
      <circle cx="14" cy="41" r="3" />
      <circle cx="34" cy="41" r="3" />
      <path d="M21 5h8l-5 8h6l-9 12 3-9h-6l3-11z" />
    </g>
    <g v-else-if="name === 'battery'">
      <rect x="9" y="9" width="30" height="33" rx="4" />
      <path d="M19 5h10M19 16l-4 9h8l-4 11 13-16h-8l4-4" />
    </g>
    <g v-else-if="name === 'efficiency'">
      <path d="M7 41h35M11 36v-9h7v9M22 36V19h7v17M33 36V10h7v26" />
      <path d="M8 22l9-8 8 4L39 5M32 5h7v7" />
    </g>
    <g v-else-if="name === 'parking'">
      <circle cx="24" cy="24" r="19" />
      <path d="M19 35V13h8a7 7 0 010 14h-8M19 27h8" />
    </g>
    <g v-else-if="name === 'schedule'">
      <circle cx="24" cy="24" r="17" />
      <path d="M24 14v11l8 5M8 8l5 5M40 8l-5 5" />
      <path d="M5 24H1M47 24h-4" />
    </g>
    <g v-else-if="name === 'multi-scene'">
      <circle cx="24" cy="24" r="5" />
      <circle cx="9" cy="11" r="4" />
      <circle cx="39" cy="11" r="4" />
      <circle cx="9" cy="38" r="4" />
      <circle cx="39" cy="38" r="4" />
      <path d="M13 14l7 7M35 14l-7 7M13 35l7-7M35 35l-7-7" />
    </g>
    <g v-else-if="name === 'substation'">
      <rect x="5" y="17" width="17" height="21" rx="2" />
      <path d="M10 17v-4M17 17v-4M9 25h9M9 31h9" />
      <path d="M34 38V10M28 17h12M30 25h8M34 10l-5 5M34 10l5 5" />
      <path d="M3 42h42" />
    </g>
    <g v-else-if="name === 'pumped'">
      <rect x="4" y="7" width="16" height="12" rx="1" />
      <rect x="28" y="28" width="16" height="12" rx="1" />
      <path d="M6 13c2.3-2 4.6-2 7 0s4.7 2 7 0M30 34c2.3-2 4.6-2 7 0s4.7 2 7 0" />
      <path d="M20 19l8 9" />
      <path d="M26 10h9M35 10l-3-3M35 10l-3 3M22 24h-9M13 24l3-3M13 24l3 3" />
    </g>
    <g v-else-if="name === 'datacenter'">
      <rect x="7" y="6" width="34" height="11" rx="2" />
      <rect x="7" y="19" width="34" height="11" rx="2" />
      <rect x="7" y="32" width="34" height="11" rx="2" />
      <path d="M13 11.5h2M13 24.5h2M13 37.5h2M29 11.5h6M29 24.5h6M29 37.5h6" />
    </g>
    <g v-else-if="name === 'factory'">
      <path d="M5 42V21l11 7V21l11 7V12h12v30z" />
      <path d="M2 42h44M33 20h5M33 27h5M33 34h5M10 34h5M21 34h5" />
    </g>
    <g v-else-if="name === 'mine'">
      <path d="M4 12h40M9 21h30M14 30h20M19 39h10" />
      <path d="M4 12l15 27M44 12L29 39" />
    </g>
    <g v-else-if="name === 'company'">
      <path d="M8 42V11l15-6v37M23 42V19l17 6v17M3 42h42" />
      <path d="M13 16h5M13 24h5M13 32h5M29 29h6M29 36h6" />
    </g>
    <g v-else-if="name === 'honor'">
      <circle cx="24" cy="17" r="12" />
      <path d="M24 10l2.4 4.8 5.3.8-3.9 3.7.9 5.3-4.7-2.5-4.7 2.5.9-5.3-3.9-3.7 5.3-.8z" />
      <path d="M15 27l-4 16 13-6 13 6-4-16" />
    </g>
    <g v-else-if="name === 'partner'">
      <circle cx="14" cy="13" r="6" />
      <circle cx="34" cy="13" r="6" />
      <path d="M3 38c0-6.1 4.9-11 11-11s11 4.9 11 11M23 38c0-6.1 4.9-11 11-11s11 4.9 11 11" />
    </g>
    <g v-else-if="name === 'culture'">
      <path d="M24 42S7 31 7 19.5A9.5 9.5 0 0124 14a9.5 9.5 0 0117 5.5C41 31 24 42 24 42z" />
    </g>
    <g v-else-if="name === 'party'">
      <path d="M11 44V5" />
      <path d="M11 8h26l-5 8 5 8H11z" />
      <path d="M22 12l1.7 3.4 3.8.6-2.8 2.6.7 3.7-3.4-1.8-3.4 1.8.7-3.7-2.8-2.6 3.8-.6z" />
    </g>
    <g v-else>
      <path d="M9 43L19 5M39 43L29 5M24 8v8M24 24v8M24 40v3" />
      <circle cx="10" cy="34" r="3" />
      <circle cx="38" cy="34" r="3" />
      <path d="M13 34h22M18 17h12" />
    </g>
  </svg>
</template>

<script>
export default {
  name: "OperationIcon",
  props: {
    name: {
      type: String,
      default: "charging",
    },
  },
};
</script>

<style scoped>
.operation-icon-svg {
  width: 100%;
  height: 100%;
  stroke: currentColor;
  stroke-width: 2.2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
</style>
